export function makeArray(obj) {
    var array = [];
    if (typeof(obj) == "object") {
        Object.keys(obj).map((e) => {
            array.push(obj[e]);
        })
    }
    return array;
}